import A11yDialog from "a11y-dialog";

/**
 * Bulk gift card
 */
var modalBulkGiftCard = {
  init: function () {
    var container = document.getElementById("modal-bulk-giftcard");
    if (!container) return;

    // Prevent duplicate initialization of the Bulk Gift Card modal.
    if (container.dataset.bulkGiftCardInitialized === "true") {
      return;
    }

    container.dataset.bulkGiftCardInitialized = "true";

    var dialog = new A11yDialog(container);

    // When the datepicker is open, Escape should close only the calendar,
    // not the entire Bulk Gift Card modal.
    document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;

        // Only handle Escape when focus is inside this modal.
        if (!container.contains(document.activeElement)) return;

        var $datepicker = $("#ui-datepicker-div");
        if (!$datepicker.is(":visible")) return;

        var dateInput = container.querySelector("#giftcard-datepicker");
        if (!dateInput) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        $(dateInput).datepicker("hide");
        dateInput.focus();
    }, true);

    var TOTAL_STEPS = 3;

    var stepPanels = container.querySelectorAll(
      ".dialog-content--body[data-step]",
    );
    var stepIndicators = container.querySelectorAll(
      ".dialog-content--steps [data-step]",
    );
    var currentStep = 1;

    // Announcer for screen readers
    var announcer = document.createElement("span");
    announcer.setAttribute("role", "status");
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("aria-atomic", "true");
    announcer.className = "sr-only";
    container.querySelector(".dialog-content").appendChild(announcer);

    function announce(msg) {
      announcer.textContent = "";
      setTimeout(function () {
        announcer.textContent = msg;
      }, 50);
    }

    // Nav buttons
    var footer = document.createElement("div");
    footer.className = "dialog-content--footer";

    var btnPrev = document.createElement("button");
    btnPrev.type = "button";
    btnPrev.className = "dialog-btn btn btn--secondary";
    btnPrev.textContent = "Back";

    var btnNext = document.createElement("button");
    btnNext.type = "button";
    btnNext.className = "dialog-btn dialog-btn--lg btn";
    btnNext.textContent = "Next";

    var btnSubmit = document.createElement("button");
    btnSubmit.type = "button";
    btnSubmit.className = "dialog-btn dialog-btn--lg btn";
    btnSubmit.textContent = "Submit request";

    var btnClose = document.createElement("button");
    btnClose.type = "button";
    btnClose.className =
      "dialog-btn dialog-btn--lg btn btn-fw-mobile js-btn-close";
    btnClose.textContent = "Close";

    var btnSubmitAnother = document.createElement("button");
    btnSubmitAnother.type = "button";
    btnSubmitAnother.className =
      "dialog-btn dialog-btn--lg btn-fw-mobile btn btn--primary-alt js-btn-submit-another";
    btnSubmitAnother.textContent = "Submit another request";

    footer.appendChild(btnPrev);
    footer.appendChild(btnNext);
    footer.appendChild(btnSubmit);
    footer.appendChild(btnSubmitAnother);
    footer.appendChild(btnClose);
    container.querySelector(".dialog-content").appendChild(footer);

    dialog.on("show", function () {
      // Trigger default selections inside the modal if nothing is checked yet
      var amtPanel = container.querySelector(".gc-create-amount");
      if (
        amtPanel &&
        !amtPanel.querySelector('[role="radio"][aria-checked="true"]')
      ) {
        var firstAmt = amtPanel.querySelector('[role="radio"]');
        if (firstAmt) firstAmt.click();
      }

      var datePanel = container.querySelector(".gc-create-date");
      if (
        datePanel &&
        !datePanel.querySelector('[role="radio"][aria-checked="true"]')
      ) {
        var firstDate = datePanel.querySelector('[role="radio"]');
        if (firstDate) firstDate.click();
      }
    });

    // Paging
    function goToStep(step, skipFocus, focusSelector) {
      var prevStep = currentStep;
      currentStep = step;

      stepPanels.forEach(function (panel) {
        var panelStep = parseInt(panel.getAttribute("data-step"), 10);
        var isActive = panelStep === currentStep;
        panel.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      stepIndicators.forEach(function (ind) {
        setTimeout(() => {
          var indStep = parseInt(ind.getAttribute("data-step"), 10);
          ind.classList.toggle("active", indStep === currentStep);
          ind.classList.toggle("completed", indStep < currentStep);
          ind.setAttribute(
            "aria-current",
            indStep === currentStep ? "step" : "false",
          );
        }, 250);
      });

      updateNavState();

      var stepLabel = getStepLabel(currentStep);

      // Populate summary when arriving at step 3
      if (currentStep === TOTAL_STEPS) {
        modalBulkGiftCard.buildSummary(container, goToStep);
      }

      // Re-evaluate next state for the new step
      updateNextState();
      bindNextStateListeners();

        // Move focus to the requested field when editing,
        // otherwise focus the step heading.
        var newPanel = container.querySelector(
            '.dialog-content--body[data-step="' + currentStep + '"]'
        );

        if (newPanel && !skipFocus) {
            var heading = newPanel.querySelector(".bgc-section-heading");

            if (heading) {
                // Keep the heading's accessible name consistent with its visible text
                // so NVDA Browse Mode does not repeat the step announcement.
                heading.setAttribute("tabindex", "-1");
                heading.removeAttribute("aria-label");
            }

            var focusTarget = focusSelector
                ? newPanel.querySelector(focusSelector)
                : null;

            if (focusTarget) {
                focusTarget.focus();
            } else if (heading) {
                heading.focus();
            }

            // Announce the destination step when navigating between steps.
            // Keep this separate from the heading's accessible name.
            announce(
                "Step " + currentStep + " of " + TOTAL_STEPS +
                ": " + stepLabel
            );
       
        }

    }


    // Ensure the first Tab after entering Steps 2 or 3
    // starts at the modal Close (X) button.
    container.addEventListener("keydown", function (e) {
        if (e.key !== "Tab" || e.shiftKey) return;
        if (currentStep !== 2 && currentStep !== 3) return;

        var activePanel = container.querySelector(
            '.dialog-content--body[data-step="' + currentStep + '"]'
        );

        if (!activePanel) return;

        var heading = activePanel.querySelector(".bgc-section-heading");
        var closeButton = container.querySelector(
            ".dialog-content--header button[data-a11y-dialog-hide]"
        );

        if (
            heading &&
            closeButton &&
            document.activeElement === heading
        ) {
            e.preventDefault();
            closeButton.focus();
        }
    });


    function getStepLabel(step) {
      var ind = container.querySelector(
        '.dialog-content--steps [data-step="' + step + '"]',
      );
      return ind ? ind.textContent.trim() : "Step " + step;
    }

    function updateNavState() {
      var isFirst = currentStep === 1;
      var isLast = currentStep === TOTAL_STEPS;

      btnPrev.style.display = isFirst ? "none" : "";
      btnNext.style.display = isLast ? "none" : "";
      btnSubmit.style.display = isLast ? "" : "none";
      btnClose.style.display = "none";
      btnSubmitAnother.style.display = "none";

      footer.classList.toggle("dialog-content--footer--single", isFirst);
    }

    // reset modal custom fields
    function resetCustomControls() {
        // Reset card type to Electronic
        var electronicBtn = container.querySelector(
            '.me-2opt-toggle [data-card-type="electronic"]'
        );

        if (electronicBtn) {
            electronicBtn.click();
        }

        // Reset gift card amount to first/default option
        var amountPanel = container.querySelector(".gc-create-amount");

        if (amountPanel) {
            var firstAmount = amountPanel.querySelector('[role="radio"]');

            if (firstAmount) {
                firstAmount.click();
            }
        }

        // Reset send date to first/default option
        var datePanel = container.querySelector(".gc-create-date");

        if (datePanel) {
            var firstDate = datePanel.querySelector('[role="radio"]');

            if (firstDate) {
                firstDate.click();
            }
        }
    }

    // Button events
    btnNext.addEventListener("click", function () {
      var errors = modalBulkGiftCard.validateStep(container, currentStep);
      if (errors.length) {
        modalBulkGiftCard.showStepErrors(container, errors);
        return;
      }
      modalBulkGiftCard.clearStepErrors(container);
      if (currentStep < TOTAL_STEPS) goToStep(currentStep + 1);
    });

    btnPrev.addEventListener("click", function () {
      if (currentStep > 1) goToStep(currentStep - 1);
    });

    btnSubmit.addEventListener("click", function () {
        var errors = modalBulkGiftCard.validateStep(container, currentStep);

        if (errors.length) {
            modalBulkGiftCard.showStepErrors(container, errors);
            return;
        }

        modalBulkGiftCard.clearStepErrors(container);

        btnSubmit.disabled = true;
        btnSubmit.setAttribute("aria-disabled", "true");

        modalBulkGiftCard.submit(container, {
            footer: footer,
            btnPrev: btnPrev,
            btnNext: btnNext,
            btnSubmit: btnSubmit,
            btnClose: btnClose,
            btnSubmitAnother: btnSubmitAnother,

            success: function () {
                modalBulkGiftCard.showSuccess(
                    container,
                    footer,
                    btnPrev,
                    btnNext,
                    btnSubmit,
                    btnClose,
                    btnSubmitAnother,
                );
            },

            failure: function () {
                btnSubmit.disabled = false;
                btnSubmit.setAttribute("aria-disabled", "false");


                console.error("Bulk gift-card request was not submitted.");

                announce(
                    "There was a problem submitting your request. Please try again."
                );
            },
        });
    });

    // Reset on close — also hides success panel
    dialog.on("hide", function () {
      if (cleanupMessageCounter) cleanupMessageCounter();
      var form = container.querySelector(".me-gc-form");
      if (form) form.reset();

      resetCustomControls();

      modalBulkGiftCard.clearStepErrors(container);

      modalBulkGiftCard.showSuccess(
        container,
        footer,
        btnPrev,
        btnNext,
        btnSubmit,
        btnClose,
        btnSubmitAnother,
        true,
      );

      goToStep(1, true);
    });

    // On success, close
    btnClose.addEventListener("click", function () {
      dialog.hide();
    });

    // On success, submit another
    btnSubmitAnother.addEventListener("click", function () {
      var form = container.querySelector(".me-gc-form");
      if (form) form.reset();
      dialog.hide();
      dialog.show();
      modalBulkGiftCard.cardTypeToggle(container);
      modalBulkGiftCard.qtyInput(container);
    });

    // Inits
    updateNavState();
    this.cardTypeToggle(container);
    this.qtyInput(container);
    this.datepickerAccessibility(container);
    this.acceptedFileTypes(container);
    this.phoneMask(container);
    this.bindFieldValidation(container);
    this.initShippingFee(container);

    var cleanupMessageCounter = this.messageCounter(container);

    // Clear field error on input
    container
      .querySelectorAll("input, textarea, select")
      .forEach(function (field) {
        if (field.id === "me-gift--totalamt") return; // owned by giftCardAmount in me.giftcards.js
        var eventType = field.type === "checkbox" ? "change" : "input";
        field.addEventListener(eventType, function () {
          if (field.classList.contains("input--error")) {
            field.classList.remove("input--error");
            field.removeAttribute("aria-invalid");
            var errorEl = container.querySelector(
              "#error-" + field.id.toLowerCase(),
            );

            if (errorEl) {
                errorEl.textContent = "";
                errorEl.classList.remove("alert-error");
                errorEl.style.display = "none";
            }


            // Also clear label error state for checkboxes
            if (field.type === "checkbox") {
              var label = field.closest("label");
              if (label) label.classList.remove("input--error");
            }
          }
        });
      });

    // Live next button state
    function updateNextState() {
        var isValid =
            modalBulkGiftCard.validateStep(container, currentStep).length === 0;

        if (currentStep === TOTAL_STEPS) {
            btnSubmit.disabled = !isValid;
            btnSubmit.setAttribute("aria-disabled", isValid ? "false" : "true");
        } else {
            btnNext.disabled = !isValid;
            btnNext.setAttribute("aria-disabled", isValid ? "false" : "true");
        }
    }


    function bindNextStateListeners() {
      container
        .querySelectorAll("input, textarea, select")
        .forEach(function (field) {
          var eventType = field.type === "checkbox" ? "change" : "input";
          // Remove before adding to avoid stacking on re-bind
          field.removeEventListener(eventType, updateNextState);
          field.addEventListener(eventType, updateNextState);
        });

      // Amount and date radiogroups fire click, not input
      container
        .querySelectorAll(
          '.gc-create-amount [role="radio"], .gc-create-date [role="radio"], .me-2opt-toggle [role="radio"]',
        )
        .forEach(function (btn) {
          btn.removeEventListener("click", updateNextState);
          btn.addEventListener("click", updateNextState);
        });
    }

    bindNextStateListeners();
    updateNextState();
  },
  getShippingFee: function (container) {
    var raw = parseFloat(container.getAttribute("data-shipping-fee"));
    return isNaN(raw) ? 0 : raw;
  },

  formatCurrency: function (amount) {
    return "$" + amount.toLocaleString("en-US");
  },

  initShippingFee: function (container) {
    var fee = this.getShippingFee(container);
    var formatted = this.formatCurrency(fee);

    // 1. Notice shown after selecting "Physical" on step 1
    var noticeSpan = container.querySelector(".bgc-shipping-fee");
    if (noticeSpan) noticeSpan.textContent = formatted;

    // Checkbox agreement label on step 2
    var agreeSpan = container.querySelector("#bulk-shipping-fee-agree-amount");
    if (agreeSpan) agreeSpan.textContent = formatted;
  },
  phoneMask: function (container) {
    var input = container.querySelector("#phone");
    if (!input) return;

    function applyMask(value) {
      var digits = value.replace(/\D/g, "").substring(0, 10);
      var len = digits.length;

      if (len === 0) return "";
      if (len <= 3) return digits;
      if (len <= 6)
        return digits.substring(0, 3) + "-" + digits.substring(3);
      return (
        digits.substring(0, 3) +
        "-" +
        digits.substring(3, 6) +
        "-" +
        digits.substring(6)
      );
    }

    input.addEventListener("input", function () {
      var pos = input.selectionStart;
      var prevLen = input.value.length;
      input.value = applyMask(input.value);
      var newLen = input.value.length;
      input.selectionStart = input.selectionEnd = pos + (newLen - prevLen);
    });

    input.addEventListener("keydown", function (e) {
      var allowed = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End",
      ];
      if (allowed.indexOf(e.key) === -1 && !/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    });
  },
  cardTypeToggle: function (container) {
    var wrapper = container.querySelector(".me-2opt-toggle--wrapper");
    if (!wrapper) return;

    var hiddenInput = wrapper.querySelector('input[name="gift-card-type"]');
    var toggleButtons = wrapper.querySelectorAll(
      ".me-2opt-toggle button[data-card-type]",
    );
    var physicalNote = wrapper.querySelector(".physical-note");
    var electronicPanels = container.querySelectorAll(
      ".modal-bulk-giftcard__electronic",
    );
    var physicalPanels = container.querySelectorAll(
      ".modal-bulk-giftcard__physical",
    );

    function selectCardType(selectedBtn) {
      toggleButtons.forEach(function (btn) {
        var isSelected = btn === selectedBtn;
        btn.classList.toggle("selected", isSelected);
        btn.setAttribute("aria-checked", isSelected ? "true" : "false");
      });

      var cardType = selectedBtn.getAttribute("data-card-type");
      var isPhysical = cardType === "physical";

      hiddenInput.value = cardType;

      physicalNote.setAttribute("aria-hidden", isPhysical ? "false" : "true");

      electronicPanels.forEach(function (panel) {
        panel.setAttribute("aria-hidden", isPhysical ? "true" : "false");
      });
      physicalPanels.forEach(function (panel) {
        panel.setAttribute("aria-hidden", isPhysical ? "false" : "true");
      });
    }

    toggleButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        selectCardType(btn);
      });
    });

    // Arrow keys move focus and select
    wrapper
      .querySelector(".me-2opt-toggle")
      .addEventListener("keydown", function (e) {
        var currentIndex = Array.prototype.indexOf.call(
          toggleButtons,
          document.activeElement,
        );
        if (currentIndex === -1) return;

        var nextIndex;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          nextIndex = (currentIndex + 1) % toggleButtons.length;
        } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          nextIndex =
            (currentIndex - 1 + toggleButtons.length) % toggleButtons.length;
        } else {
          return;
        }

        e.preventDefault();
        toggleButtons[nextIndex].focus();
        selectCardType(toggleButtons[nextIndex]);
      });

    var defaultBtn = wrapper.querySelector('[data-card-type="electronic"]');
    if (defaultBtn) {
      selectCardType(defaultBtn);
    }
  },
    datepickerAccessibility: function (container) {
        var datepicker = container.querySelector("#giftcard-datepicker");
        if (!datepicker) return;

        // Live region to announce calendar month changes to screen readers
        var monthAnnouncement = document.createElement("span");
        monthAnnouncement.id = "bulk-giftcard-month-announcement";
        monthAnnouncement.className = "sr-only";
        monthAnnouncement.setAttribute("role", "status");
        monthAnnouncement.setAttribute("aria-live", "polite");
        monthAnnouncement.setAttribute("aria-atomic", "true");

        container.querySelector(".dialog-content").appendChild(monthAnnouncement);

        // Apply accessible labels to calendar month navigation links
        function updateCalendarNavigationLabels() {
            var $datepickerDiv = $("#ui-datepicker-div");

            $datepickerDiv.find(".ui-datepicker-next")
                .attr("aria-label", "Next Month");

            $datepickerDiv.find(".ui-datepicker-prev")
                .attr("aria-label", "Previous Month");
        }

        var dateDescription = container.querySelector(
            "#bulk-giftcard-date-description"
        );

        if (!dateDescription) {
            dateDescription = document.createElement("span");
            dateDescription.id = "bulk-giftcard-date-description";
            dateDescription.className = "sr-only";

            datepicker.insertAdjacentElement("afterend", dateDescription);
        }

        var existingDescription = datepicker.getAttribute("aria-describedby");

        datepicker.setAttribute(
            "aria-describedby",
            Array.from(new Set(
                (existingDescription || "").split(/\s+/).filter(Boolean)
                    .concat(dateDescription.id)
            )).join(" ")
        );

        function updateDateDescription() {
            var value = datepicker.value.trim();

            if (!value) {
                dateDescription.textContent = "";
                return;
            }

            try {
                var date = $.datepicker.parseDate("m/dd/yy", value);

                var formattedDate = date.toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric"
                });

                dateDescription.textContent = "Selected date: " + formattedDate;
            } catch (e) {
                dateDescription.textContent = "";
            }
        }

        // Restrict send dates to tomorrow through one year from today.
        $(datepicker).datepicker("option", {
            minDate: 1,
            maxDate: "+1y"
        });

        $(datepicker).on(
            "input.bulkDateDescription change.bulkDateDescription blur.bulkDateDescription focus.bulkDateDescription",
            updateDateDescription
        );

        updateDateDescription();

        // When the calendar opens, ensure it is inside the modal
        // and apply accessible navigation labels.
        $(datepicker).on("focus.bulkDatepicker click.bulkDatepicker", function () {
            setTimeout(function () {
                var $datepickerDiv = $("#ui-datepicker-div");

                if ($datepickerDiv.length && !$datepickerDiv.closest(container).length) {
                    $datepickerDiv.appendTo(container);
                }

                updateCalendarNavigationLabels();
            }, 0);
        });

    },
  qtyInput: function (container) {
    var wrapper = container.querySelector(".gc-bulk-qty");
    if (!wrapper) return;
    
    if (wrapper.dataset.qtyInitialized === "true") return;

    var input = wrapper.querySelector('input[type="number"]');
    var btnMinus = wrapper.querySelector(".step-btn__minus");
    var btnPlus = wrapper.querySelector(".step-btn__plus");

    if (!input || !btnMinus || !btnPlus) return;

    wrapper.dataset.qtyInitialized = "true";

    var errorEl = container.querySelector("#error-" + input.id);

    // Live region for quantity changes
    var qtyAnnouncement = document.createElement("span");
    qtyAnnouncement.className = "sr-only";
    qtyAnnouncement.setAttribute("role", "status");
    qtyAnnouncement.setAttribute("aria-live", "polite");
    qtyAnnouncement.setAttribute("aria-atomic", "true");

    wrapper.appendChild(qtyAnnouncement);

    var qtyAnnouncementTimer;

    function announceQuantity(value) {
        clearTimeout(qtyAnnouncementTimer);

        qtyAnnouncement.textContent = "";

        qtyAnnouncementTimer = setTimeout(function () {
            qtyAnnouncement.textContent = "Quantity: " + value;
        }, 100);
    }



    function getMin() {
      var min = parseInt(input.getAttribute("min"), 10);
      return isNaN(min) ? null : min;
    }

    function getMax() {
      var max = parseInt(input.getAttribute("max"), 10);
      return isNaN(max) ? null : max;
    }

    function hasLeadingZero(val) {
      return /^0\d/.test(val);
    }

    function markError(msg) {
      input.classList.add("input--error");
      input.setAttribute("aria-invalid", "true");
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.classList.add("alert-error");
      }
    }

    function clearError() {
      input.classList.remove("input--error");
      input.removeAttribute("aria-invalid");
      if (errorEl) {
        errorEl.textContent = "";
        errorEl.classList.remove("alert-error");
      }
    }

    function updateButtonStates() {
      var val = parseInt(input.value, 10);
      var min = getMin();
      var max = getMax();

      btnMinus.setAttribute(
        "aria-disabled",
        min !== null && val <= min ? "true" : "false",
      );
      btnPlus.setAttribute(
        "aria-disabled",
        max !== null && val >= max ? "true" : "false",
      );
    }

    btnMinus.addEventListener("click", function () {
      var val = parseInt(input.value, 10);
      var min = getMin();
      if (isNaN(val)) val = 0;
      if (min !== null && val <= min) return;
      input.value = val - 1;
      clearError();
      updateButtonStates();
      input.dispatchEvent(new Event("input", { bubbles: true }));

      announceQuantity(input.value);

    });

    btnPlus.addEventListener("click", function () {
      var val = parseInt(input.value, 10);
      var max = getMax();
      if (isNaN(val)) val = 0;
      if (max !== null && val >= max) return;
      input.value = val + 1;
      clearError();
      updateButtonStates();
      input.dispatchEvent(new Event("input", { bubbles: true }));

      announceQuantity(input.value);
    });

    // Live check
    input.addEventListener("input", function (e) {
      if (input.validity.badInput) {
        input.value = "";
        markError("A valid quantity is required.");
        e.stopImmediatePropagation();
        return;
      }

      if (hasLeadingZero(input.value)) {
        markError("Please remove the leading zero.");
        e.stopImmediatePropagation();
        return;
      }

      var min = getMin();
      var max = getMax();
      var val = parseInt(input.value, 10);

      if (input.value.trim() !== "" && min !== null && val < min) {
        markError("Quantity must be at least " + min + ".");
        e.stopImmediatePropagation();
        return;
      }

      if (input.value.trim() !== "" && max !== null && val > max) {
        markError("Quantity cannot be greater than " + max.toLocaleString() + ".");
        e.stopImmediatePropagation();
        return;
      }


      if (input.value.trim() !== "") clearError();
    });

    input.addEventListener("blur", function () {
      var min = getMin();
      var max = getMax();

      if (input.value.trim() === "") {
        markError("A valid quantity is required.");
        updateButtonStates();
        return;
      }

      if (hasLeadingZero(input.value)) {
        markError("Please remove the leading zero.");
        updateButtonStates();
        return;
      }

      var val = parseInt(input.value, 10);

      if (min !== null && val < min) {
        markError("Quantity must be at least " + min + ".");
        updateButtonStates();
        return;
      }

      if (max !== null && val > max) {
        markError("Quantity cannot be greater than " + max.toLocaleString() + ".");
        updateButtonStates();
        return;
      }

      clearError();
      updateButtonStates();
    });

    updateButtonStates();
  },
  acceptedFileTypes: function (container) {
    var wrapper = container.querySelector(".custom-file-input");
    if (!wrapper) return;

    var fileUploadField = wrapper.querySelector("input[type='file']");
    var fileTypesAttr = fileUploadField.getAttribute("accept");
    var output = container.querySelector(".file-accepted-types-hint span");

    // Parse accepted extensions into a lowercase array, e.g. [".csv", ".doc", ...]
    var acceptedExtensions = fileTypesAttr
      ? fileTypesAttr.split(",").map(function (ext) {
          return ext.trim().toLowerCase();
        })
      : [];

    if (output && fileTypesAttr) {
      output.textContent = fileTypesAttr.split(",").join(", ");
    }

    var fileNameSpan = wrapper.querySelector(".file-name");
    var errorEl = container.querySelector("#error-" + fileUploadField.id);

    function getExtension(filename) {
      var idx = filename.lastIndexOf(".");
      return idx === -1 ? "" : filename.substring(idx).toLowerCase();
    }

    function markInvalid(msg) {
      fileUploadField.classList.add("input--error");
      fileUploadField.setAttribute("aria-invalid", "true");
      if (errorEl) errorEl.textContent = msg;
    }

    function clearInvalid() {
      fileUploadField.classList.remove("input--error");
      fileUploadField.removeAttribute("aria-invalid");
      if (errorEl) errorEl.textContent = "";
    }

    fileUploadField.addEventListener("change", function () {
      var file = fileUploadField.files.length > 0 ? fileUploadField.files[0] : null;

      if (!file) {
        if (fileNameSpan) fileNameSpan.textContent = "";
        clearInvalid();
        return;
      }

      var ext = getExtension(file.name);
      var isValid =
        acceptedExtensions.length === 0 || acceptedExtensions.indexOf(ext) !== -1;

      if (!isValid) {
        // Reject the file: clear the input so it can't be submitted
        fileUploadField.value = "";
        errorEl.classList.add("alert-error");
        if (fileNameSpan) fileNameSpan.textContent = "";
        markInvalid(
          "Please upload a file with one of the accepted extensions: " +
            acceptedExtensions.join(", "),
        );
        return;
      } else {
        errorEl.classList.remove("alert-error");
      }

      clearInvalid();
      if (fileNameSpan) fileNameSpan.textContent = file.name;
    });
  },
  bindFieldValidation: function (container) {
    function markError(field, msg) {
        field.classList.add("input--error");
        field.setAttribute("aria-invalid", "true");

        var errorEl = container.querySelector("#error-" + field.id);

        if (errorEl) {
            errorEl.textContent = msg || "This field is required.";
            errorEl.classList.add("alert-error");
            errorEl.style.display = "flex";
        }
    }

    function clearError(field) {
        field.classList.remove("input--error");
        field.removeAttribute("aria-invalid");

        var errorEl = container.querySelector("#error-" + field.id);

        if (errorEl) {
            errorEl.textContent = "";
            errorEl.classList.remove("alert-error");
            errorEl.style.display = "none";
        }
    }

    // Full name
    var fullname = container.querySelector("#fullname");
    if (fullname) {
      fullname.addEventListener("blur", function () {
        if (fullname.value.trim() === "") {
          markError(fullname, "This field is required.");
        } else {
          clearError(fullname);
        }
      });
    }

    // Email
    var email = container.querySelector("#email");
    if (email) {
      email.addEventListener("blur", function () {
        if (email.value.trim() === "") {
          markError(email, "This field is required.");
        } else if (
          typeof isValidEmail === "function" &&
          !isValidEmail(email.value)
        ) {
          markError(email, "Please enter a valid email address.");
        } else {
          clearError(email);
        }
      });
    }

    // Phone
    var phone = container.querySelector("#phone");
    if (phone) {
      phone.addEventListener("blur", function () {
        var digits = phone.value.replace(/\D/g, "");
        if (digits.length === 0) {
          markError(phone, "This field is required.");
        } else if (digits.length < 10) {
          markError(phone, "Please enter a complete 10-digit phone number.");
        } else {
          clearError(phone);
        }
      });
    }

    // Recipient emails (step 2) — optional field, only validate format if non-empty
    var recipient = container.querySelector("#Recipient");
    if (recipient) {
      recipient.addEventListener("blur", function () {
        if (recipient.value.trim() === "") {
          clearError(recipient);
          updateTotalLabel();
          return;
        }
        if (
          typeof validateEmails === "function" &&
          !validateEmails(recipient.value)
        ) {
          markError(recipient, "One or more email addresses are invalid.");
        } else {
          clearError(recipient);
        }
        updateTotalLabel();
      });

      recipient.addEventListener("input", function () {
        updateTotalLabel();
      });
    }


    // Send date
    var datepicker = container.querySelector("#giftcard-datepicker");

    if (datepicker) {
        datepicker.addEventListener("blur", function () {
            var value = datepicker.value.trim();

            if (value === "") {
                markError(datepicker, "This field is required.");
                return;
            }

            try {
                var selected = $.datepicker.parseDate("m/dd/yy", value);

                var today = new Date();
                today.setHours(0, 0, 0, 0);

                var minDate = new Date(today);
                minDate.setDate(minDate.getDate() + 1);

                var maxDate = new Date(today);
                maxDate.setFullYear(maxDate.getFullYear() + 1);

                if (selected < minDate) {
                    markError(datepicker, "Please select tomorrow's date or a future date.");
                } else if (selected > maxDate) {
                    markError(datepicker, "Please select a date within the next 12 months.");
                } else {
                    clearError(datepicker);
                }
            } catch (e) {
                markError(datepicker, "Please enter a valid date.");
            }
        });
    }




    function updateTotalLabel() {
      var totalEl = container.querySelector("#totalLabel");
      if (!totalEl) return;

      var total = (
        container.querySelector("#me-gift--totalamt").value || ""
      ).replace(/[^\d]/g, "");
      var emailCount =
        typeof countValidEmails === "function"
          ? countValidEmails(recipient.value)
          : 0;

      if (emailCount > 0 && total && !isNaN(parseInt(total, 10))) {
        totalEl.innerHTML = "Recipients: " + emailCount;
      } else {
        totalEl.innerHTML = "";
      }
    }

    // Physical shipping fields
    var physicalPanel = container.querySelector(
      ".modal-bulk-giftcard__physical",
    );
    if (physicalPanel) {
      var shippingFields = [
        { id: "#order-recipient-name", msg: "This field is required." },
        { id: "#bulk-street-address", msg: "This field is required." },
        { id: "#city", msg: "This field is required." },
      ];

      shippingFields.forEach(function (def) {
        var field = physicalPanel.querySelector(def.id);
        if (!field) return;
        field.addEventListener("blur", function () {
          if (field.value.trim() === "") {
            markError(field, def.msg);
          } else {
            clearError(field);
          }
        });
      });

      var stateField = physicalPanel.querySelector("#Address_BillingState");
      if (stateField) {
        function validateState() {
          if (stateField.value.trim() === "") {
            markError(stateField, "This field is required.");
          } else {
            clearError(stateField);
          }
        }

        stateField.addEventListener("change", validateState);
        stateField.addEventListener("blur", validateState);
      }

        var zipField = physicalPanel.querySelector("#zip");

        if (zipField) {
            zipField.addEventListener("blur", function () {
                var val = zipField.value.trim();
                var usZip = /^\d{5}(-\d{4})?$/;
                var caZip = /^[A-Z]\d[A-Z][ ]?\d[A-Z]\d$/i;

                if (val === "") {
                    markError(zipField, "This field is required.");
                } else if (caZip.test(val)) {
                    markError(zipField, "6-digit postal codes are not supported.");
                } else if (!usZip.test(val)) {
                    markError(zipField, "5 digits are required.");
                } else {
                    clearError(zipField);
                }
            });
        }

      // Agree to fee
      var shippingAgreeField = physicalPanel.querySelector(
        "#shipping_fee_agree",
      );
      if (shippingAgreeField) {
        function validateShippingAgree() {
          if (!shippingAgreeField.checked) {
            markError(
              shippingAgreeField,
              "You must agree to the shipping fee to continue.",
            );
          } else {
            clearError(shippingAgreeField);
          }
        }

        shippingAgreeField.addEventListener("blur", validateShippingAgree);
        shippingAgreeField.addEventListener("change", validateShippingAgree);
      }

      // Agree to terms (step 3)
      var agreeField = container.querySelector("#agree");
      if (agreeField) {
        function validateAgree() {
          var agreeLabel = agreeField.closest("label");
          if (!agreeField.checked) {
            markError(agreeField, "You must agree to the terms to continue.");
            if (agreeLabel) agreeLabel.classList.add("input--error");
          } else {
            clearError(agreeField);
            if (agreeLabel) agreeLabel.classList.remove("input--error");
          }
        }
        agreeField.addEventListener("blur", validateAgree);
        agreeField.addEventListener("change", validateAgree);
      }
    }
  },
  messageCounter: function (container) {
    var textarea = container.querySelector("#Message");
    var counter = container.querySelector("#gc-count-notify-x");
    var metrics = container.querySelector("#gc-count--metrics");
    if (!textarea || !counter) return;

    var maxChar = 160;
    var alertLimit = 150;
    var alertEl = null;

    textarea.addEventListener("input", function () {
      var charCount = textarea.value.length;
      var charRemain = maxChar - charCount;

      counter.textContent = charRemain;

      if (charCount > alertLimit) {
        // Remove existing alert first
        var existing = container.querySelector("#card-message-alert");
        if (existing) existing.remove();

        alertEl = document.createElement("div");
        alertEl.setAttribute("role", "alert");
        alertEl.setAttribute("id", "card-message-alert");
        alertEl.setAttribute("class", "sr-only");
        alertEl.textContent =
          "You have " +
          charRemain +
          " characters of " +
          maxChar +
          " remaining.";

        // Append inside the modal, not body
        container.querySelector(".dialog-content").appendChild(alertEl);
      }

      if (metrics) {
        metrics.style.color = charCount >= maxChar ? "#D73C54" : "#2E3543";
      }
    });

    // Clean up alert when modal closes
    return function cleanup() {
      var existing = container.querySelector("#card-message-alert");
      if (existing) existing.remove();
    };
  },
  validateStep: function (container, step) {
    var errors = [];

    if (step === 1) {
      var fullname = container.querySelector("#fullname");
      var email = container.querySelector("#email");
      var phone = container.querySelector("#phone");

      if (!fullname || fullname.value.trim() === "") errors.push(fullname);

      if (!email || email.value.trim() === "") {
        errors.push(email);
      } else if (
        typeof isValidEmail === "function" &&
        !isValidEmail(email.value)
      ) {
        errors.push(email);
      }

      if (!phone || phone.value.trim() === "") {
        errors.push(phone);
      } else if (phone.value.replace(/\D/g, "").length < 10) {
        errors.push(phone);
      }
    }

    if (step === 2) {
      // Amount: check if any radio is aria-checked="true" in the bulk modal's amount group
      var amtPanel = container.querySelector(".gc-create-amount");
      var selectedAmt = amtPanel
        ? amtPanel.querySelector('[role="radio"][aria-checked="true"]')
        : null;
      if (!selectedAmt) {
        errors.push(amtPanel);
      } else if (
        selectedAmt.closest("[data-amt]").getAttribute("data-amt") === "custom"
      ) {
        // Custom amount — must have a valid numeric value
        var customInput = container.querySelector("#me-gift--totalamt");
        var rawAmt = customInput
          ? parseFloat(customInput.value.replace(/[^\d.]/g, ""))
          : 0;
        if (!rawAmt || rawAmt < 50 || rawAmt > 1000) errors.push(customInput);
      }



      // Date: check if any radio is aria-checked="true"
      var selectedDate = container.querySelector(
        '.gc-create-date [role="radio"][aria-checked="true"]',
      );
        if (!selectedDate) {
            errors.push(container.querySelector(".gc-create-date"));
        } else if (selectedDate.getAttribute("data-date") === "later") {
            var datepicker = container.querySelector("#giftcard-datepicker");

            if (!datepicker || datepicker.value.trim() === "") {
                errors.push(datepicker);
            } else {
                try {
                    var selected = $.datepicker.parseDate(
                        "m/dd/yy",
                        datepicker.value.trim()
                    );

                    var today = new Date();
                    today.setHours(0, 0, 0, 0);

                    var minDate = new Date(today);
                    minDate.setDate(minDate.getDate() + 1);

                    var maxDate = new Date(today);
                    maxDate.setFullYear(maxDate.getFullYear() + 1);

                    if (selected < minDate || selected > maxDate) {
                        errors.push(datepicker);
                    }


                } catch (e) {
                    errors.push(datepicker);
                }
            }
        }

      // Quantity
      var qtyField = container.querySelector("#bulk-giftcard-qty");
      if (!qtyField || qtyField.value.trim() === "") {
        errors.push(qtyField);
      } else {
        var qtyVal = parseInt(qtyField.value, 10);
        var qtyMin = parseInt(qtyField.getAttribute("min"), 10);
        var qtyMax = parseInt(qtyField.getAttribute("max"), 10);

        if (
            isNaN(qtyVal) ||
            (!isNaN(qtyMin) && qtyVal < qtyMin) ||
            (!isNaN(qtyMax) && qtyVal > qtyMax)
        ) {
            errors.push(qtyField);
        }
      }

      // Physical shipping — only if physical card type is selected
      var cardType = container.querySelector('input[name="gift-card-type"]');
      if (cardType && cardType.value === "physical") {
        var physicalPanel = container.querySelector(
          ".modal-bulk-giftcard__physical",
        );

        var recipientName = physicalPanel.querySelector(
          "#order-recipient-name",
        );
        var street = physicalPanel.querySelector("#bulk-street-address");
        var city = physicalPanel.querySelector("#city");
        var state = physicalPanel.querySelector("#Address_BillingState");
        var zip = physicalPanel.querySelector("#zip");

        if (!recipientName || recipientName.value.trim() === "")
          errors.push(recipientName);
        if (!street || street.value.trim() === "") errors.push(street);
        if (!city || city.value.trim() === "") errors.push(city);
        if (!state || state.value.trim() === "") errors.push(state);

        // ZIP — empty check first, then format validation
        if (!zip || zip.value.trim() === "") {
            errors.push(zip);
        } else {
            var zipVal = zip.value.trim();
            var usZip = /^\d{5}(-\d{4})?$/;

            if (!usZip.test(zipVal)) {
                if (errors.indexOf(zip) === -1) errors.push(zip);
            }
        }

        // Shipping fee checkbox
        var shippingAgree = physicalPanel.querySelector("#shipping_fee_agree");
        if (!shippingAgree || !shippingAgree.checked)
          errors.push(shippingAgree);
      }

      var recipientField = container.querySelector("#Recipient");
      if (recipientField && recipientField.value.trim() !== "") {
        if (
          typeof validateEmails === "function" &&
          !validateEmails(recipientField.value)
        ) {
          errors.push(recipientField);
        }
      }
    }

    if (step === 3) {
      var agree = container.querySelector("#agree");
      if (!agree || !agree.checked) errors.push(agree);
    }

    return errors;
  },
  showStepErrors: function (container, errors) {
    // Clear existing first
    modalBulkGiftCard.clearStepErrors(container);

    // Mark each invalid field
    errors.forEach(function (el) {
      if (!el) return;
      el.classList.add("input--error");
      el.setAttribute("aria-invalid", "true");
    });

    // Announce to screen readers
    var announcer = container.querySelector('[role="status"]');
    if (announcer) {
      announcer.textContent = "";
      setTimeout(function () {
        announcer.textContent =
          "Please complete all required fields before continuing.";
      }, 50);
    }

    // Focus first invalid field
    var firstEl = errors[0];
    if (firstEl) {
      // If it's a group (amount/date), focus the first button in it
      var focusTarget =
        firstEl.matches('[role="radio"]') ||
        firstEl.tagName === "INPUT" ||
        firstEl.tagName === "TEXTAREA"
          ? firstEl
          : firstEl.querySelector('[role="radio"], input, button');
      if (focusTarget) focusTarget.focus();
    }
  },

  clearStepErrors: function (container) {
    container.querySelectorAll(".input--error").forEach(function (el) {
      el.classList.remove("input--error");
      el.removeAttribute("aria-invalid");
    });

    container.querySelectorAll('[id^="error-"]').forEach(function (el) {
        el.textContent = "";
        el.style.removeProperty("display");
        el.classList.remove("alert-error");
    });

    var amtError = container.querySelector(".gc-create-amount__custom .gc-amount-error");
    if (amtError) amtError.remove();

    var agreeLabel = container.querySelector("#agree")
      ? container.querySelector("#agree").closest("label")
      : null;
    if (agreeLabel) agreeLabel.classList.remove("input--error");
  },
  buildSummary: function (container, goToStep) {
    // Your info
    var get = function (selector) {
      var el = container.querySelector(selector);
      return el ? (el.value || "").trim() : "";
    };

    // State -- get option abbreviation
    var getSelectedText = function (selector) {
      var el = container.querySelector(selector);
      if (!el || !el.selectedOptions || !el.selectedOptions.length) return "";
      return (el.selectedOptions[0].text || "").trim();
    };

    // Apply "empty" css class to empty row parent
    function markEmptyRow(row, value) {
      if (row && row.children[1]) {
        row.children[1].classList.toggle(
          "empty",
          value === "—" || value === "" || value === null,
        );
      }
    }

    function escapeHtml(str) {
      var div = document.createElement("div");
      div.textContent = str;
      return div.innerHTML;
    }

    var name = get("#fullname");
    var email = get("#email");
    var phone = get("#phone");
    var org = get("#organization");
    var cardType = get('input[name="gift-card-type"]');
    var cardTypeLabel = cardType === "physical" ? "Physical" : "Electronic";

    var yourInfoRows = container.querySelectorAll(
      ".summary-box.your-info .gc-item-details--row",
    );
    if (yourInfoRows.length >= 5) {
      yourInfoRows[0].children[1].textContent = name;
      yourInfoRows[1].children[1].textContent = email;
      yourInfoRows[2].children[1].textContent = phone;
      yourInfoRows[3].children[1].textContent = org || "—";
      yourInfoRows[4].children[1].textContent = cardTypeLabel;

      // Find empty rows
      markEmptyRow(yourInfoRows[0], name);
      markEmptyRow(yourInfoRows[1], email);
      markEmptyRow(yourInfoRows[2], phone);
      markEmptyRow(yourInfoRows[3], org || "—");
      markEmptyRow(yourInfoRows[4], cardTypeLabel);
    }

    // Request details
    var amtPanel = container.querySelector(".gc-create-amount");
    var selectedAmt = amtPanel
      ? amtPanel.querySelector('[role="radio"][aria-checked="true"]')
      : null;
    var customAmt = get("#me-gift--totalamt");

    var amount = selectedAmt
      ? selectedAmt.closest("[data-amt]").getAttribute("data-amt") === "custom"
        ? customAmt
        : selectedAmt.closest("[data-amt]").getAttribute("data-amt") // use data-amt value, not button text
      : "—";

    var qty = get("#bulk-giftcard-qty") || "—";

    var selectedDate = container.querySelector(
      '.gc-create-date [role="radio"][aria-checked="true"]',
    );
    var dateType = selectedDate ? selectedDate.getAttribute("data-date") : null;

    function formatDate(value) {
        if (!value) return "";

        var parts = value.split("/");
        if (parts.length !== 3) return value;

        var month = parts[0].padStart(2, "0");
        var day = parts[1].padStart(2, "0");
        var year = parts[2];

        return month + "/" + day + "/" + year;
    }

    var sendDate =
        dateType === "later"
            ? formatDate(get("#giftcard-datepicker")) || "—"
            : "As soon as possible";

    var sender = get("#gc_bulk_sender") || "—";
    var recipients = get("#Recipient");
    var recipientList = recipients
      ? recipients
          .split(",")
          .map(function (e) {
            return e.trim();
          })
          .filter(Boolean)
      : [];

    var MAX_VISIBLE = 3;
    var recipientDisplay;

    if (recipientList.length === 0) {
      recipientDisplay = "—";
    } else if (recipientList.length <= MAX_VISIBLE) {
      recipientDisplay = recipientList.join("<br>");
    } else {
      var visible = recipientList.slice(0, MAX_VISIBLE);
      var remaining = recipientList.length - MAX_VISIBLE;
      recipientDisplay = visible.join("<br>") + "<br>&hellip;";
    }

    var requestRows = container.querySelectorAll(
      ".summary-box.request-details .gc-item-details--row",
    );
    if (requestRows.length >= 5) {
      requestRows[0].children[1].textContent = amount
        ? "$" + parseFloat(amount.replace(/[^0-9.]/g, "")).toLocaleString()
        : "—";
      requestRows[1].children[1].textContent = qty;
      requestRows[2].children[1].textContent = sendDate;
      requestRows[3].children[1].textContent = sender;
      requestRows[4].children[1].innerHTML = recipientDisplay;

      // Hide sender name and recipient emails rows for physical orders
      requestRows[3].style.display = cardType === "physical" ? "none" : "";
      requestRows[4].style.display = cardType === "physical" ? "none" : "";

      // Find Empty rows
      markEmptyRow(requestRows[0], amount || "—");
      markEmptyRow(requestRows[1], qty);
      markEmptyRow(requestRows[2], sendDate);
      markEmptyRow(requestRows[3], sender);
      markEmptyRow(
        requestRows[4],
        recipientDisplay === "—" ? "—" : recipientDisplay,
      );
    }

    var shippingFee = modalBulkGiftCard.getShippingFee(container);

    // Physical: shipping address
    var recipientName = get("#order-recipient-name");
    var street = get("#bulk-street-address");
    var apt = get("#apt");
    var city = get("#city");
    var stateSelect = container.querySelector("#Address_BillingState");
    var state = stateSelect && stateSelect.selectedIndex >= 0
      ? stateSelect.options[stateSelect.selectedIndex].text.trim()
      : "";
    var zip = get("#zip");

    // Desktop: single comma-joined line (unchanged behavior)
    var addressParts = [recipientName, street, apt, city, state, zip].filter(Boolean);
    var addressStr = addressParts.join(", ");

    // Mobile: grouped across 3 lines
    //   Line 1: Order Recipient Name
    //   Line 2: Address information (street + apt)
    //   Line 3: City, State ZIP
    var streetLine = [street, apt].filter(Boolean).join(" ");
    var cityStateZip = [
      [city, state].filter(Boolean).join(", "),
      zip,
    ].filter(Boolean).join(" ");

    var mobileLines = [recipientName, streetLine, cityStateZip].filter(Boolean);
    var mobileAddressHtml = mobileLines
      .map(function (line) {
        return escapeHtml(line);
      })
      .join("<br>");

    var shippingBodyDesktop = container.querySelector(
      ".summary-box.summary-box__wide.modal-bulk-giftcard__physical .shipping-address--desktop",
    );
    if (shippingBodyDesktop) {
      shippingBodyDesktop.textContent = addressStr || "—";
      shippingBodyDesktop.classList.toggle("empty", !addressStr);
    }

    var shippingBodyMobile = container.querySelector(
      ".summary-box.summary-box__wide.modal-bulk-giftcard__physical .shipping-address--mobile",
    );
    if (shippingBodyMobile) {
      shippingBodyMobile.innerHTML = mobileLines.length
        ? mobileAddressHtml
        : "—";
      shippingBodyMobile.classList.toggle("empty", !mobileLines.length);
    }

    // Populate step-3 shipping fee display
    var shippingFeeDisplay = container.querySelector("#bulk-shipping-fee-display");
    if (shippingFeeDisplay) {
      shippingFeeDisplay.textContent = modalBulkGiftCard.formatCurrency(shippingFee);
    }

    // Electronic: custom message
    var message = get("#Message") || "—";
    var messageBody = container.querySelector(
      ".summary-box.summary-box__wide.modal-bulk-giftcard__electronic .summary-box--body p",
    );
    if (messageBody) {
      messageBody.textContent = message;
      messageBody.classList.toggle("empty", message === "—");
    }

    // Estimated total
    var qtyNum = parseInt(qty, 10) || 0;
    var amtNum = parseFloat((amount || "").replace(/[^0-9.]/g, "")) || 0;
    var shipping = cardType === "physical" ? shippingFee : 0;
    var total = qtyNum * amtNum + shipping;
    var totalEl = container.querySelector("#bulk-gc-total");
    if (totalEl) {
      totalEl.textContent = total > 0 ? "$" + total.toLocaleString() : "—";
    }

    // Edit buttons
    var editButtons = container.querySelectorAll(".edit-step[data-edit-step]");

    editButtons.forEach(function (btn) {
        var newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        newBtn.addEventListener("click", function (e) {
            e.preventDefault();

            var targetStep = parseInt(newBtn.getAttribute("data-edit-step"), 10);
            var focusSelector = newBtn.getAttribute("data-focus-target");

            if (!isNaN(targetStep)) {
                goToStep(targetStep, false, focusSelector);
            }
        });
    });

  },

    submit: function (container, controls) {
        var submitEvent = new CustomEvent("bulkGiftCard:submit", {
            bubbles: true,
            cancelable: true,
            detail: {
                container: container,
                controls: controls,
            },
        });

        var notHandled = container.dispatchEvent(submitEvent);

        if (notHandled) {
            console.error(
                "Bulk gift-card submission handler was not available."
            );

            if (controls && typeof controls.failure === "function") {
                controls.failure();
            }
        }
    },

  showSuccess: function (
    container,
    footer,
    btnPrev,
    btnNext,
    btnSubmit,
    btnClose,
    btnSubmitAnother,
    reset,
  ) {
    var successPanel = container.querySelector(".dialog-content--success");
    var stepsBar = container.querySelector(".dialog-content--steps");
    var stepPanels = container.querySelectorAll(
      ".dialog-content--body[data-step]",
    );

    if (reset) {
      successPanel.setAttribute("aria-hidden", "true");
      stepsBar.setAttribute("aria-hidden", "false");
      footer.setAttribute("aria-hidden", "false");
      footer.classList.remove("dialog-content--footer--last");
      // Reset submit button state
      btnSubmit.disabled = false;
      btnSubmit.setAttribute("aria-disabled", "false");
      return;
    }

    stepPanels.forEach(function (panel) {
      panel.setAttribute("aria-hidden", "true");
    });
    stepsBar.setAttribute("aria-hidden", "true");

    btnPrev.style.display = "none";
    btnNext.style.display = "none";
    btnSubmit.style.display = "none";
    btnClose.style.display = "";
    btnSubmitAnother.style.display = "";
    footer.classList.remove("dialog-content--footer--single");
    footer.classList.add("dialog-content--footer--last");

    successPanel.setAttribute("aria-hidden", "false");
    successPanel.setAttribute("tabindex", "-1");
    successPanel.focus();
  },
};

export default modalBulkGiftCard;
